/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_cloud_logic_custom": [
        {
            "name": "bdmformsapi",
            "endpoint": "https://9w8qbp11ef.execute-api.ap-southeast-2.amazonaws.com/master",
            "region": "ap-southeast-2"
        }
    ],
    "aws_content_delivery_bucket": "bdm-forms-20200326172539-hostingbucket-master",
    "aws_content_delivery_bucket_region": "ap-southeast-2",
    "aws_content_delivery_url": "http://bdm-forms-20200326172539-hostingbucket-master.s3-website-ap-southeast-2.amazonaws.com",
    "aws_user_files_s3_bucket_region": "ap-southeast-2"
};


export default awsmobile;
